module.exports = __webpack_public_path__ + "assets/img/yypt_d_p2.591b5ff5.png";